import { isWebView } from '@fourthwall/utils';
export const WebViewRemover = ({ children }) => {
    return isWebView() ? null : children;
};
